import Content from '../../content';

namespace('IO.Views.TwoFactorAuths', function (exports) {
  'use strict';

  var Show = Content.extend({
    dom: {
      MASKED_PASSWORD: '.mask-password',
    },

    render: function () {
      this.$(this.dom.MASKED_PASSWORD).maskPassword();
    },
  });

  exports.Show = Show;
});
